/**
 * @generated SignedSource<<0a66baba010937dee22e34f66937cd59>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueViewLayoutFieldHeading_IssueViewFieldHeading$data = {
  readonly description: string | null | undefined;
  readonly fieldId: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"FieldEditIcon">;
  readonly " $fragmentType": "ui_issueViewLayoutFieldHeading_IssueViewFieldHeading";
};
export type ui_issueViewLayoutFieldHeading_IssueViewFieldHeading$key = {
  readonly " $data"?: ui_issueViewLayoutFieldHeading_IssueViewFieldHeading$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewLayoutFieldHeading_IssueViewFieldHeading">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_issueViewLayoutFieldHeading_IssueViewFieldHeading",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "FieldEditIcon"
    },
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    }
  ],
  "type": "JiraIssueField",
  "abstractKey": "__isJiraIssueField"
};

(node as any).hash = "9a26cae487cf7e8a0ffe026bc65b2a48";

export default node;
